import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-38883968"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "money-component" }
const _hoisted_2 = { class: "symbol" }
const _hoisted_3 = { class: "formattedMoney" }
const _hoisted_4 = { class: "formattedMoney" }
const _hoisted_5 = { class: "symbol" }

import { computed } from 'vue';

interface Props {
  money: number | string;
  currency: string;
  style: 'CM' | 'MC' | 'CMF' | 'CMB';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoneyView',
  props: {
    money: { default: 0 },
    currency: { default: 'USD' },
    style: { default: 'CMF' }
  },
  setup(__props: any) {

const props = __props;

// format tiền
const formattedMoney = computed(() => {
    let currencyFormat = 'en-US'
    if(props.currency == 'VND') {
        currencyFormat = 'vi-VN'
    }
      return new Intl.NumberFormat(currencyFormat).format(Number(props.money));

//   return new Intl.NumberFormat(currencyFormat, {
//     style: 'currency',
//     currency: props.currency,
//   }).format(Number(props.money));
});

// ký hiệu tiền
const symbol = computed(() => {
  if (props.style === 'CMF' || props.style === 'CMB') {
    return '$';
  }
  return props.currency;
});

// vị trí ký hiệu
const isPrefix = computed(() => {
  return props.style === 'CM' || props.style === 'CMF';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isPrefix.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(symbol.value), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(formattedMoney.value), 1)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(formattedMoney.value), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(symbol.value), 1)
        ], 64))
  ]))
}
}

})